module.exports = __webpack_public_path__ + "img/s2P18.b3e6bfbc.png";